module.exports = __webpack_public_path__ + "static/InterFaceXBold-Italic-00ebd3f6c94c88faf09de3e880a07d5e.woff2";